import React from 'react'
import { Classes } from 'jss'

// styles
import { sheet } from './sheet'
import injectSheet from 'react-jss'
// utils
import cx from 'classnames'
import { cssVarColors, cssVarTextColors } from 'lib/cssSelector'

type ColorsType = 'mainLight' | 'successLight'
type VariantType = 'filled' | 'outline'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  classes: Classes
  text: string
  color?: ColorsType
  variant?: VariantType
  Icon?: React.FC<React.SVGProps<SVGSVGElement>>
}
const { main, lightMain, successLight } = cssVarColors
const { success: textSuccess, main: textMain } = cssVarTextColors

const ColorSchema = (color?: ColorsType, variant?: VariantType): React.CSSProperties => {
  if (variant === 'outline') {
    return {
      backgroundColor: 'transparent',
      border: '1px solid #1e293b',
      color: '#1e293b'
    }
  }

  switch (color) {
    case 'successLight':
      return { backgroundColor: successLight, color: textMain }

    case 'mainLight':
    default:
      return { backgroundColor: lightMain, color: '#475569' }
  }
}

const Badge = ({ text, color, variant = 'filled', classes, className, Icon, style, ...props }: Props) => {
  return (
    <div
      {...props}
      style={{ ...ColorSchema(color, variant), ...style }}
      className={cx([classes.base, 'text-medium', className])}
    >
      {Icon && <Icon className={classes.icon} />}
      {text}
    </div>
  )
}

export default injectSheet(sheet)(Badge)
